import { FC } from 'react';
import { Divider, Flex, Regular, Semibold, Sparkles, useToggle } from '@zazume/zzm-base';
import { useI18n } from '#hooks/useI18n';
import { DocumentMetadata } from '#/models';
import { MetadataHelper } from '#/models/helpers/document/MetadataHelper';
import { ShowMore } from '#/components/pages/detail/FieldsSection/atoms/ShowMore';

interface Props {
  metadata?: DocumentMetadata;
}

export const Metadata: FC<Props> = ({ metadata }) => {
  const { t, languageVO } = useI18n();

  const { value: showInfo, toggle: tooggleShowInfo } = useToggle(false);

  if (!metadata) {
    return null;
  }

  const metadataHelper = new MetadataHelper(metadata);
  const type = metadataHelper.formatType(t);
  const fields = metadataHelper.getFormattedData(t, languageVO);

  if (!fields.length) {
    return null;
  }

  return (<>
    <Divider/>
    <Flex gap="s2" align="center">
      <Sparkles size={24} color="Primary"/>
      <Semibold variant="M">{t('documents.metadata.title')}</Semibold>
    </Flex>
    <Flex direction="column" gap="s2">
      <Regular variant="XS" color="Gray500">{t('documents.type')}</Regular>
      <Semibold variant="S">{type}</Semibold>
    </Flex>
    {showInfo && fields.map(({ field, value }) => (
      <Flex key={field} direction="column" gap="s2">
        <Regular variant="XS" color="Gray500">{field}</Regular>
        <Semibold variant="S">{value}</Semibold>
      </Flex>
    ))}
    <ShowMore handleShowInfo={tooggleShowInfo} showMoreInfo={showInfo}/>
  </>);
};
